var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "step__boxes" },
    _vm._l(_vm.items, function (item, index) {
      return _c(
        "div",
        {
          key: index,
          staticClass: "step__box",
          on: {
            click: function ($event) {
              return _vm.selectOption(item)
            },
          },
        },
        [
          _vm._v("\n    " + _vm._s(item.label) + "\n    "),
          _c("span", { staticClass: "step__circle" }, [
            _c("svg", { attrs: { height: "35", width: "35" } }, [
              _c("circle", {
                attrs: {
                  cx: "20",
                  cy: "20",
                  r: "10",
                  stroke: "#e9eef3",
                  "stroke-width": "2",
                  fill: "white",
                },
              }),
              _vm._v(
                "\n        Sorry, your browser does not support inline SVG.\n      "
              ),
            ]),
          ]),
        ]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }